"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyTabContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const molecules_1 = require("../../molecules");
const ItemsList_1 = require("../ItemsList");
const bridge_1 = require("@completeanatomy/bridge");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const analytics_1 = require("@completeanatomy/analytics");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const constants_1 = require("../../constants");
const hooks_1 = require("../../hooks");
const utils_1 = require("../../utils");
const noop_1 = __importDefault(require("lodash/noop"));
function SupplyTabContent({ type, onResize = noop_1.default, }) {
    var _a, _b;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, device_1.usePlatform)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const tabContent = (0, hooks_1.useTabContent)(type);
    const bridge = (0, bridge_1.useBridge)();
    const location = (0, react_router_dom_1.useLocation)();
    const analytics = (0, analytics_1.useAnalytics)();
    const { items = [], extra: { names } = {} } = tabContent;
    const supplyTitle = (0, utils_1.getSupplyLabel)(type, t, names);
    const getSelectedPartName = (supplyType) => {
        switch (supplyType) {
            case bridge_schema_1.SupplyTraceSelectedPartType.HeartPart:
                return t(i18n_1.Strings.originMode.heart);
            case bridge_schema_1.SupplyTraceSelectedPartType.SkeletalPart:
                return t(i18n_1.Strings.originMode.skeletal);
            case bridge_schema_1.SupplyTraceSelectedPartType.InnervationPart:
                return t(i18n_1.Strings.originMode.innervation);
            case bridge_schema_1.SupplyTraceSelectedPartType.Nerve:
                return t(i18n_1.Strings.originMode.nerve);
            case bridge_schema_1.SupplyTraceSelectedPartType.Vein:
                return t(i18n_1.Strings.originMode.vein);
            case bridge_schema_1.SupplyTraceSelectedPartType.Artery:
                return t(i18n_1.Strings.originMode.artery);
            case bridge_schema_1.SupplyTraceSelectedPartType.None:
            default:
                return '';
        }
    };
    const selectedSupplyDescription = {
        name: getSelectedPartName((_a = tabContent === null || tabContent === void 0 ? void 0 : tabContent.selectedPart) === null || _a === void 0 ? void 0 : _a.type),
        text: (_b = tabContent === null || tabContent === void 0 ? void 0 : tabContent.selectedPart) === null || _b === void 0 ? void 0 : _b.name,
    };
    const stringifiedSupplyDescription = JSON.stringify([
        selectedSupplyDescription,
    ]);
    const handleSelect = (0, react_1.useCallback)(({ action, title }) => {
        const path = `/mode/${(0, constants_1.getTabKeyByType)(type)}`;
        const segmentation = {
            name: title,
            type,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
        navigate(path, { replace: path === location.pathname });
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxSupplyItem({ type, action });
    }, [analytics, bridge, location.pathname, navigate, type]);
    const handleDeselect = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.selectInfoBoxSupplyItem({
            type,
            action: bridge_schema_1.SupplyTraceAction.Default,
        });
        navigate(-1);
    }, [bridge, navigate, type]);
    const onClick = (0, react_1.useCallback)((index) => {
        if (!items) {
            return;
        }
        const item = items[index];
        item.isSelected ? handleDeselect() : handleSelect(item);
    }, [handleSelect, handleDeselect, items]);
    if (!tabContent) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledItemsList, { onResize: onResize, onClick: onClick, "data-e2e": 'SupplyTabContent_StyledItemsList', children: items || [] }), supplyTitle && (0, jsx_runtime_1.jsx)(Title, { "$isMobile": isMobile, "data-e2e": 'SupplyTabContent_Title', children: supplyTitle }), names && ((0, jsx_runtime_1.jsx)(ItemsContainer, { "$isMobile": isMobile, "data-e2e": 'SupplyTabContent_ItemsContainer', children: names.map((item, i) => ((0, jsx_runtime_1.jsx)(Item, { "$isMobile": isMobile, "$multiple": names.length > 1, "data-e2e": 'SupplyTabContent_Item', children: item.replace(/\((Right|Left)\)/, '') }, i))) })), (tabContent === null || tabContent === void 0 ? void 0 : tabContent.selectedPart) && ((0, jsx_runtime_1.jsx)(SelectedPartDescription, { hasScroll: false, "data-e2e": 'SupplyTabContent_SelectedPartDescription', children: stringifiedSupplyDescription }))] }));
}
exports.SupplyTabContent = SupplyTabContent;
const StyledItemsList = (0, styled_components_1.default)(ItemsList_1.ItemsList) `
  flex-grow: 0;

  height: unset;
`;
const Title = styled_components_1.default.div `
  padding: 7px 0 7px 15px;

  font-size: 14px;
  text-transform: uppercase;

  user-select: text;

  ${({ $isMobile }) => $isMobile &&
    (0, styled_components_1.css) `
      margin-top: 8px;
      padding: 0 0 5px 0;
    `};
`;
const ItemsContainer = (0, styled_components_1.default)(ui_1.ScrollView) `
  flex-direction: column;

  height: unset;
  min-height: ${({ $isMobile }) => ($isMobile ? '10vh' : 'unset')};

  margin: 0 7px 7px 0;
  padding-left: 15px;

  ${({ $isMobile }) => $isMobile &&
    (0, styled_components_1.css) `
      margin: 0;
      padding: 0;
    `};
`;
const Item = styled_components_1.default.div `
  margin-top: ${({ $isMobile }) => ($isMobile ? 8 : 0)}px;

  font-weight: ${({ $isMobile }) => ($isMobile ? 300 : 'inherit')};
  font-size: 15px;
  line-height: 23px;

  user-select: text;

  ${({ $isMobile, $multiple }) => !$isMobile &&
    $multiple &&
    (0, styled_components_1.css) `
      &::before {
        margin-right: 5px;

        font-size: 6px;
        vertical-align: middle;

        content: '●';
      }
    `}
`;
const SelectedPartDescription = (0, styled_components_1.default)(molecules_1.Description) `
  height: fit-content;

  padding-left: 15px;
`;
